<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { closeModalById } from '@/utils/modal'
import upgradeIcon from '@/assets/images/board/upgrade--svip.webp'

interface Props {
  /** 关闭回调 */
  onClose?: () => void
}

const props = defineProps<Props>()

const modalId = 'modal-ssvip-concurrent-limit'
defineOptions({ modalId })

const show = ref(false)

onMounted(() => {
  show.value = true
})

const closeModal = () => {
  show.value = false
}

const handleAfterClose = () => {
  closeModalById(modalId)
}

const handleClickClose = () => {
  closeModal()
  props.onClose?.()
}
</script>

<template>
  <a-modal
    wrapClassName="modal-ssvip-concurrent-limit"
    v-model:open="show"
    :centered="true"
    width="auto"
    :footer="null"
    :keyboard="true"
    :maskClosable="true"
    :closable="false"
    :afterClose="handleAfterClose"
  >
    <div class="modal-content">
      <div class="icon-wrapper">
        <img :src="upgradeIcon" alt="upgrade" class="upgrade-icon" />
      </div>

      <div class="text-content">
        <div class="title">VVIP专属队列已满，请稍作等待</div>
        <div class="desc">
          当前任务正在为您极速生成中，请等待部分任务完成后再提交新灵感。
        </div>
      </div>

      <div class="action-wrapper">
        <div class="btn-confirm" @click="handleClickClose">知道了</div>
      </div>
    </div>
  </a-modal>
</template>

<style lang="scss">
.modal-ssvip-concurrent-limit {
  .ant-modal-content,
  .ant-modal-body {
    overflow: visible;
  }

  .ant-modal-content {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
  }
}
</style>

<style lang="scss" scoped>
.modal-content {
  position: relative;
  width: 360px;
  border-radius: 40px;
  background: #1e1e20 url('@/assets/images/board/upgradeModalBg--svip.webp') no-repeat center top;
  background-size: cover;
  border: 1px solid rgba(255, 220, 206, 0.6);
  padding: 64px 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: visible;
}

.icon-wrapper {
  position: absolute;
  top: -63px;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
  width: 96px;
  height: 128px;
  display: flex;
  justify-content: center;
  align-items: center;

  .upgrade-icon {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.text-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px 16px;

  .title {
    font-family: PingFang SC, sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.4;
    text-align: center;
    background: linear-gradient(90deg, #f66c02 0%, #feaa47 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .desc {
    font-family: PingFang SC, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.43;
    text-align: center;
    color: rgba(235, 235, 245, 0.6);
  }
}

.action-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 40px 0;
}

.btn-confirm {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  border-radius: 24px;
  background: linear-gradient(90deg, #ffb266 0%, #ffb266 100%);
  border: 1px solid rgba(235, 235, 245, 0.3);
  color: #18181b;
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
}
</style>
